import React from 'react'
import SetPasswordForm from 'pages/Identity/SetPasswordForm'

export default () => {
  return (
    <SetPasswordForm heading='Please reset your password' buttonText='Reset Password' />
  )
}
